import { MobileOnlyOptions } from "./MobileOnlyOptions";
import { USALandingOptions } from "./USALandingOptions";
import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate21: LandingPageConfigOptions = {
  consentAge: 21,
  ...MobileOnlyOptions,
  ...USALandingOptions,
};
